import { APP_NAVIGATION } from "../../config";
import { SITE_NAVIGATION } from "../../config";
import {
  computePreRenderRoutes,
  getNavigationUrl,
  computeNavigation,
} from "./Navigation";
import { values as Rvalues, keys as Rkeys } from "ramda";
import { logger } from "../../utils/logger";
import { isNative } from "../Device/device";

const ROUTES = [
  ...Rkeys(APP_NAVIGATION.routes),
  ...Rkeys(APP_NAVIGATION.menu.subRoutes),
  ...Rkeys(SITE_NAVIGATION.routes),
  ...Rkeys(SITE_NAVIGATION.menu.subRoutes),
];

type APP_GUARD = keyof typeof APP_NAVIGATION.routeGuards;

function getUrl({
  route,
  param = undefined,
}: {
  route: string;
  param?: string;
}) {
  return getNavigationUrl({ route, param, navigation: APP_NAVIGATION });
}

function preRenderRoutes() {
  if (isNative()) {
    logger.info("Rendering navigation for native build");
    return computePreRenderRoutes(
      [...Rvalues(APP_NAVIGATION.routes)],
      APP_NAVIGATION.menu,
      APP_NAVIGATION.root
    );
  } else {
    return computePreRenderRoutes(
      [...Rvalues(SITE_NAVIGATION.routes)],
      SITE_NAVIGATION.menu,
      SITE_NAVIGATION.root
    );
  }
}

function computeAppNavigation(guard: APP_GUARD) {
  return computeNavigation(APP_NAVIGATION, guard);
}

function computeSiteNavigation() {
  return computeNavigation(SITE_NAVIGATION, null);
}

export {
  getUrl,
  preRenderRoutes,
  computeAppNavigation,
  computeSiteNavigation,
  ROUTES,
};
